import LABColor from '../classes/lab-color';

const assumeXYZ = (spectrum) => {
  if (spectrum > 0.008856) {
    return spectrum ** (1 / 3);
  }
  return spectrum * 7.787 + 16 / 116;
};

const xyz2lab = (xyzColor) => {
  const x = assumeXYZ(xyzColor.x / 0.95047);
  const y = assumeXYZ(xyzColor.y / 1);
  const z = assumeXYZ(xyzColor.z / 1.08883);

  const l = 116 * y - 16;
  const a = 500 * (x - y);
  const b = 200 * (y - z);

  return new LABColor(l, a, b);
};

export default xyz2lab;
